// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DynamicFormFieldModel from '../../model/dynamic-form-field-model';
import DynamicFormFieldDTO from '../dto/dynamic-form-field-dto';
import dtoSchema from '../schemas/dynamic-form-field-schema';
import DynamicFormChoiceModel from '../../model/dynamic-form-choice-model';

export default abstract class DynamicFormFieldModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DynamicFormFieldDTO>) {
    super();
    if (data) {
      this.dynamicFormFieldDefinitionId = data.dynamicFormFieldDefinitionId;
      this.orderSequence = data.orderSequence;
      this.description = data.description ?? undefined;
      this.isMandatory = data.isMandatory;
      this.enableMultiline = data.enableMultiline;
      this.type = data.type;
      this.groupFields = data.groupFields?.map((i) => DynamicFormFieldModel.toModel(i)) ?? [];
      this.choices = data.choices?.map((i) => DynamicFormChoiceModel.toModel(i)) ?? [];
    }
  }
  /**
  * @type {uuid}
  */
  dynamicFormFieldDefinitionId?: string;
  /**
  * @type {int32}
  */
  orderSequence?: number;
  /**
  */
  description?: string;
  /**
  */
  isMandatory?: boolean;
  /**
  */
  enableMultiline?: boolean;
  /**
  * @type {int32}
  */
  type?: number;
  /**
  */
  groupFields?: DynamicFormFieldModel[];
  /**
  */
  choices?: DynamicFormChoiceModel[];

  static toModel(dto: DeepPartial<DynamicFormFieldDTO>): DynamicFormFieldModel;
  static toModel(dto: DeepPartial<DynamicFormFieldDTO> | undefined | null): DynamicFormFieldModel | undefined;
  static toModel(dto: DeepPartial<DynamicFormFieldDTO> | undefined | null): DynamicFormFieldModel | undefined {
    return dto ? new DynamicFormFieldModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DynamicFormFieldModel> | DynamicFormFieldModel): DynamicFormFieldDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      dynamicFormFieldDefinitionId: unwrapped.dynamicFormFieldDefinitionId,
      orderSequence: unwrapped.orderSequence,
      description: unwrapped.description,
      isMandatory: unwrapped.isMandatory,
      enableMultiline: unwrapped.enableMultiline,
      type: unwrapped.type,
      groupFields: unwrapped.groupFields,
      choices: unwrapped.choices,
    } as DynamicFormFieldDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DynamicFormFieldModel, can not map to DynamicFormFieldDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
